// extracted by mini-css-extract-plugin
module.exports = {"container":"_31ksQy","img":"_1Kiv2_"};